import React from 'react'

import { deleteDataFromApi, getDataFromApi, postDataFromApi, putDataFromApi } from '../../../../services/commonServices';
import { toast } from 'react-toastify';
import { handleCalibrationCreateUpdate } from '../Purchase/Calibration/CalibrationHandler';
import { transferStocksCreateApi, transferStocksDeleteApi, transferStocksGetApi, transferStocksUpdateApi } from '../../../../services/api';

export const getTransferStock = async (transferStockId, setformData, status, setIsOverlayLoader) => {
    try {
        const getTransferStocks = transferStocksGetApi(transferStockId)
        let res;
        res = await getDataFromApi(getTransferStocks)
        if (res.data.status === 200) {


            setformData((previousData) => {
                return {
                    0: {
                        ...previousData,
                        ...res?.data?.data,

                        // Item
                        fk_item_id:
                            status === "View"
                                ? res?.data?.data?.item_rm_code
                                : res?.data?.data?.st_fk_item_id,

                        // -------- From Transfer Details --------

                        fk_company_id:
                            status === "View"
                                ? res?.data?.data?.from_company_name
                                : res?.data?.data?.st_fk_from_company_id,

                        st_fk_from_department_id:
                            status === "View"
                                ? res?.data?.data?.from_department_name
                                : res?.data?.data?.st_fk_from_department_id,

                        stock_is_branch_record: true,

                        stock_fk_lab_id:
                            status === "View"
                                ? ""
                                : res?.data?.data?.st_fk_from_lab_id,

                        st_fk_from_branch_id:
                            status === "View"
                                ? res?.data?.data?.from_branch_name
                                : res?.data?.data?.st_fk_from_branch_id,

                        // -------- Item Stock Info --------

                        stock_closing_qty: res?.data?.data?.st_closing_qty,

                        stock_minimum_qty: res?.data?.data?.st_minimum_qty,

                        stock_eligbal_qty:  res?.data?.data?.st_eligible_qty,

                        stock_transfer_qty: res?.data?.data?.st_transfer_quantity,

                        st_remarks: res?.data?.data?.st_remarks,

                        // -------- To Transfer Details --------

                        st_fk_to_company_id:
                            status === "View"
                                ? res?.data?.data?.to_company_name
                                : res?.data?.data?.st_fk_to_company_id,

                        st_fk_to_department_id:
                            status === "View"
                                ? res?.data?.data?.to_department_name
                                : res?.data?.data?.st_fk_to_department_id,

                        stock_fk_lab_id_to:
                            status === "View"
                                ? ""
                                : res?.data?.data?.st_fk_to_lab_id,

                        st_fk_to_branch_id:
                            status === "View"
                                ? res?.data?.data?.to_branch_name
                                : res?.data?.data?.st_fk_to_branch_id,

                        // Transfer In Qty
                        stock_transfer_in_qty: res?.data?.data?.st_received_stock
                    }
                }
            })

        }
        else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } catch (error) {
        // console.log('errrr', error)
    }
}

export const handleTransferStocksCreateAndUpdate = async (formData, handleSubmit, setIsOverlayLoader,
    navigate,
    status) => {
    try {

        let isValidate = handleSubmit();
        if (!isValidate) {
            return false;
        }

        // const hasInvalidStockQty = stockFields.some(
        //     (key) => Number(formData[0]?.[key]) <= 0
        // );

        // if (hasInvalidStockQty) {
        //     toast.error("Stock quantity must be greater than 0", {
        //         position: "top-right",
        //         autoClose: 2000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         theme: "light",
        //     });
        //     return;
        // }
        const payload = {
            st_transfer_id: formData[0]?.st_transfer_id,
            st_fk_item_id: formData[0]?.fk_item_id,
            st_fk_from_company_id: formData[0]?.fk_company_id,
            st_fk_to_company_id: formData[0]?.st_fk_to_company_id,
            st_fk_from_branch_id: formData[0]?.st_fk_from_branch_id,
            st_fk_to_branch_id: formData[0]?.st_fk_to_branch_id,
            st_fk_from_department_id: formData[0]?.st_fk_from_department_id,
            st_fk_to_department_id: formData[0]?.st_fk_to_department_id,
            st_transfer_quantity: formData[0]?.stock_transfer_qty,
            st_closing_qty: formData[0]?.stock_closing_qty,
            st_minimum_qty: formData[0]?.stock_minimum_qty,
            st_eligible_qty: formData[0]?.stock_eligbal_qty,
            st_remarks: formData[0]?.st_remarks,
            st_status: status
        }
        if (payload.st_fk_from_branch_id == payload.st_fk_to_branch_id) {
            toast.error("From Branch and To Branch cannot be the same.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return
        }
        else if (payload.st_transfer_quantity > payload.st_eligible_qty) {
            toast.error("Transfer Out Qty cannot be larger than eligible quantity", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return
        }


        let res;
        if (formData[0]?.st_transfer_id) {
            let updateChemicalStock = transferStocksUpdateApi()
            res = await putDataFromApi(updateChemicalStock, payload)

        } else {

            res = await postDataFromApi(transferStocksCreateApi, payload);

        }

        if (res?.data?.status === 200) {

            toast.success(res?.data?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            navigate("/transfer-stocks")

        } else {
            setIsOverlayLoader(false)
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }

    } catch (error) {
        // console.log('errrr', error)
    }
}

export const handleTransferStocksDelete = async (
    TransferStockId,
    setIsDelete,
    getAllListingData,
    setPopupIndex

) => {
    try {
        const payload = {
            st_transfer_id: TransferStockId,

        }

        let res = await deleteDataFromApi(transferStocksDeleteApi, payload);
        if (res?.data?.status === 200) {
            toast.success(res.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            getAllListingData();
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    catch (ex) { }
    finally {
        setIsDelete(false);
        setPopupIndex(-1);
    }


}

